import { createSlice } from "@reduxjs/toolkit";
import { SearchCatalogArgs } from "../query-args/searchCatalog";

export const LearningPathAddNewContentSlice = createSlice({
  name: "LearningPathAddNewContentSlice",
  initialState: {
    data: {
      pageSize: 12,
      pageNumber: 1,
      relevance: false,
      sortKey: "_score",
      requestDto: {
        indices: ["content", "lynda", "imocha", "content_modified", "quiz"],
        searchRequest: "",
        filters: {
          status: ["published"],
          dateFilter: "ACTIVE"
        },
        smartSearch: false
      },
      sortOrder: "DESC"
    } as SearchCatalogArgs
  },
  reducers: {
    setCatalog(state, action) {
      state.data = action.payload;
    }
  }
});

export default LearningPathAddNewContentSlice;
export const LearningPathAddNewContentSliceActions =
  LearningPathAddNewContentSlice.actions;
